import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { InventoryBoxQrsListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";

export const requestGetInventoryBoxQr = async (
  boxId: string
): Promise<InventoryBoxQrsListItem> => {
  return await instance.get(buildUrl(ApiRoutesInventory.InventoryBoxQr, boxId));
};
